<template>
  <div>
    <Modal
      v-model="modelIndex"
      width="678"
      class="contact-model"
      title=""
      footer-hide
      @on-visible-change="visibleChange"
      :closable="false"
    >
      <!-- <div slot="close">
        <i class="iconfont">&#xe6bb;</i>
      </div> -->

      <div class="contact-content">
        <div class="bg">
          <p>联系我们</p>
          <img
            :src="$store.state.static_img_url + 'pic/contact/bg-icon.png'"
            class="img1"
          >
          <img
            :src="$store.state.static_img_url + 'pic/contact/bg.png'"
            class="img2"
          >
        </div>
        <div class="info">
          <div class="list">
            <div
              v-for="item,index in contact_list"
              :key="index"
            >
              <div>
                <div class="p1">{{item.title}}</div>
                <div class="line"></div>
                <div class="p2">{{item.name}}</div>
                <div class="p2">{{item.mobile}}</div>
              </div>
              <img :src="$store.state.static_img_url + item.ewm" />
            </div>
          </div>
          <div class="button">
            <span @click="modelIndex = false">我知道了</span>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  props: ['contactModel'],
  data() {
    return {
      modelIndex: false,
      contact_list: [
        { title: '体验反馈', name: '孙老师', mobile: '18523202324（微信同号）', ewm: 'pic/contact/syc.png' },
        { title: '内容服务', name: '唐老师', mobile: '13102347860（微信同号）', ewm: 'pic/contact/nrxq.png' },
        { title: '数据服务', name: '唐老师', mobile: '13102347860（微信同号）', ewm: 'pic/contact/nrxq.png' },
        { title: '动脉橙机构版', name: '扫码二维码', mobile: '申请开通试用', ewm: 'pic/contact/dmc.png' }
      ]
    }
  },
  methods: {
    visibleChange(val) {
      this.$emit('contactCb', val)
    }
  },
  watch: {
    contactModel(bl) {
      this.modelIndex = bl
    }
  }
}
</script>
<style lang="stylus" scoped>
.contact-model
  >>>.ivu-modal-wrap
    display flex
    align-items center
    .ivu-modal
      top auto
      .ivu-modal-close
        i
          color #fff
          font-size 18px
      .ivu-modal-body
        padding 0
      .ivu-modal-content
        border-radius 0
      .contact-content
        .bg
          text-align center
          position relative
          height 64px
          background #fff
          p
            position absolute
            left 32px
            top 16px
            color #FFFFFF
            font-size 24px
          .img1
            position absolute
            height 112px
            width 206px
            right 60px
            top -56px
          .img2
            height 64px
            width 100%
            display block
        .info
          padding 24px
          .list
            display grid
            grid-template-columns repeat(2, 1fr)
            grid-gap 10px
            >div
              background-color #F9F9F9
              padding 16px 20px
              display flex
              justify-content space-between
              .line
                width 20px
                height 1px
                background rgba(250, 122, 80, 1)
                margin 6px 0 10px
              .p1
                font-size 18px
                color rgba(34, 34, 34, 1)
                line-height 25px
                margin-top 4px
              .p2
                font-size 14px
                color rgba(85, 85, 85, 1)
                line-height 20px
              img
                width 90px
                height 90px
        .button
          margin-top 24px
          text-align center
          span
            display inline-block
            width 120px
            height 36px
            background #FA7A50
            border-radius 2px
            color #fff
            font-size 14px
            line-height 36px
            text-align center
            cursor pointer
            &:hover
              background #FC9C7C
</style>
